import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import ASpaceInBetweenAnother from '../ASpaceInBetweenAnother/a.space.inbetween.another.vue';

@Component({
    components: {
        ASpaceInBetweenAnother
    }
})
export default class LPComparableSummary extends Vue {
    public title: string = 'LPComparableSummary';

    @Prop({ default: 1 })
    public page: any;

    @Prop({ default: undefined })
    public data: any;

    @Prop({ default: '' })
    public addr: any;

    @Prop({
        default: () => {
            return {
                propertyType: '',
                bedrooms: '',
                bedroomsPlus: '',
                washrooms: '',
                garages: '',
                picture: '',
            };
        }
    })
    public propertyInfo: any;

    @Prop({
        default: () => {
            return {
                comparitives: [],
                prediction: 0,
            };
        }
    })
    public cmaResult: any;

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }
}
